import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { MobileTimeslot, MobileViewWrapper } from './primitives';
import { useTimesgridViewedMetric } from '../utils/metrics';

export default function MobileTimeslotsView({
    focusedIndex,
    focusedElementRef,
    locationId,
    nextAvailability,
    onClickTimeslot,
    onFocus,
    onBlur,
    onKeyDown,
    providerId,
    searchRequestId,
    sendMetric,
    startDate,
    times,
    timeslotComponent: TimeslotComponent = MobileTimeslot,
}) {
    const containerRef = useTimesgridViewedMetric({
        locationId,
        nextAvailability,
        providerId,
        searchRequestId,
        sendMetric,
        startDate,
        times,
    });

    return (
        <div role="grid">
            <MobileTimeslotsViewWrapper ref={containerRef} role="row">
                {times[0].timeslots.map(
                    (
                        { startTime, url, formattedStartTime, ariaLabel },
                        index
                    ) => {
                        const isFocused = focusedIndex === index;
                        return (
                            <TimeslotComponent
                                aria-label={ariaLabel}
                                data-day-index={0}
                                data-timeslot-index={index}
                                data-starttime={startTime}
                                data-test="timesgrid-timeslot"
                                data-uem-id="timeslot-mobile"
                                data-url={url}
                                href={url}
                                key={startTime}
                                onBlur={onBlur}
                                onClick={onClickTimeslot}
                                onFocus={onFocus}
                                onKeyDown={onKeyDown}
                                ref={isFocused ? focusedElementRef : undefined}
                                role="gridcell"
                                tabIndex={isFocused ? 0 : -1}
                                className="skiptranslate"
                                target="_top"
                            >
                                {formattedStartTime}
                            </TimeslotComponent>
                        );
                    }
                )}
            </MobileTimeslotsViewWrapper>
        </div>
    );
}

MobileTimeslotsView.propTypes = {
    times: PropTypes.arrayOf(
        PropTypes.shape({
            date: PropTypes.string,
            timeslots: PropTypes.Array,
        })
    ),
    onClickTimeslot: PropTypes.func.isRequired,
    timeslotComponent: PropTypes.elementType,
    searchRequestId: PropTypes.string,
};

export const MobileTimeslotsViewWrapper = styled(MobileViewWrapper)`
    flex-direction: row;
    justify-content: flex-start;
    overflow-x: auto;
`;
